export const AUTH_LOCAL_STORAGE_KEY = 'auth';
export const JWT_LOCAL_STORAGE_KEY = 'jwt';
